import { onMount } from "solid-js";
import * as styles from "./css/ErrorScreen.module.css";
import { Container, Backdrop, Heading, Text } from "@gui/components";
import { PointerLockControls } from "@controllers/controls";
const ErrorScreen = props => {
    onMount(() => {
        const controler = PointerLockControls.getInstance();
        controler.unlock();
    });
    return (<Backdrop centered dark>
            <Container>
                <Heading class={styles.heading}>An error occurred</Heading>
                <Text>{props.error.message}</Text>
            </Container>
        </Backdrop>);
};
export default ErrorScreen;
